var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconHomeText = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 48 44"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#ACACAC",
  d: "M33.5 14.1v11.4h-19V14.1L24 6.5zm-17.4.769V23.9h15.8v-9.032L24 8.548zm10.094 5.08h-4.387v-1.024h4.387z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#999",
  d: "M27.003 37.193v2.53h-6.045v-2.53zM20 36.598v-.733h3.525v-.596c-1.547-.063-2.417-.478-2.412-1.23-.005-.815 1.035-1.235 2.871-1.24 1.846.005 2.876.425 2.871 1.24.005.752-.85 1.167-2.402 1.23v.596h3.526v.733zm.41-4.112v-.713h3.115v-.81h.928v.81h3.076v.713zm1.465 6.524h4.229v-1.104h-4.229zm.225-4.97c-.005.395.664.605 1.884.605 1.23 0 1.885-.21 1.885-.606 0-.4-.654-.596-1.885-.605-1.22.01-1.89.205-1.884.605"
})));
export default SvgIconHomeText;